import type { VectorSeed, PollQuestionSeed, MaturityLabel } from "./types";

// Canonical 5 readiness vectors — extracted verbatim from the demo's data.json.
// seedScore is the starting value shown before any real responses arrive.
export const VECTOR_SEEDS: (VectorSeed & { seedScore: number })[] = [
  {
    index: 1,
    label: "AI's role in the organization is clearly defined and commonly understood",
    shortLabel: "AI Role Clarity",
    benchmark: 4,
    color: "#7C3AED",
    seedScore: 3.2,
  },
  {
    index: 2,
    label: "The right AI and workflow tools are available and used appropriately",
    shortLabel: "Tools & Workflow",
    benchmark: 4,
    color: "#0078d4",
    seedScore: 3.8,
  },
  {
    index: 3,
    label: "Organizational structures and processes align to how AI is/will be leveraged",
    shortLabel: "Org Alignment",
    benchmark: 3,
    color: "#00b4d8",
    seedScore: 2.6,
  },
  {
    index: 4,
    label: "Employees have the right skills to achieve business outcomes today, and a process exists to develop future skills",
    shortLabel: "Skills & Capability",
    benchmark: 4,
    color: "#f59e0b",
    seedScore: 2.9,
  },
  {
    index: 5,
    label: "AI investments are contributing to transformational (not incremental) value",
    shortLabel: "Transformational Value",
    benchmark: 4,
    color: "#10b981",
    seedScore: 2.4,
  },
];

export const QUESTION_SEEDS: PollQuestionSeed[] = [
  {
    vectorIndex: 1,
    text: "How clearly has leadership defined AI's role in the organization?",
    factor: "Factor 1: AI's role in the organization is clearly defined and commonly understood.",
  },
  {
    vectorIndex: 2,
    text: "How well do current AI/workflow tools support how work actually gets done?",
    factor: "Factor 2: The right AI and workflow tools are available and used appropriately.",
  },
  {
    vectorIndex: 3,
    text: "How well are structures, governance, and workflows aligned to AI-enabled work?",
    factor: "Factor 3: Organizational structures and processes align to how AI is/will be leveraged.",
  },
  {
    vectorIndex: 4,
    text: "How confident are employees in the skills needed to work effectively with AI?",
    factor: "Factor 4: Employees have the right skills to achieve business outcomes today, and a process exists to develop future skills.",
  },
  {
    vectorIndex: 5,
    text: "To what extent is AI creating measurable transformational value, not just incremental efficiency?",
    factor: "Factor 5: AI investments are contributing to transformational (not incremental) value.",
  },
];

export const MATURITY_SCALE: { value: number; label: MaturityLabel }[] = [
  { value: 1, label: "Ideating" },
  { value: 2, label: "Experimenting" },
  { value: 3, label: "Optimizing" },
  { value: 4, label: "Transforming" },
  { value: 5, label: "Leading" },
];

export const DEFAULT_WORKSHOP = {
  title: "Workforce AI Readiness",
  client: "EY & Microsoft",
  facilitator: "EY × Microsoft",
  sessionLabel: "Day 1",
};
